import { gql } from "@/graphql/typed-gql"

import { PROGRESS_REPORT_FIELDS, REPORT_ACTION_FIELDS } from "@/graphql/queries/reports"

/**
 * Asks for a report. `audience` is ignored for a learner, who always gets their
 * own — the server overrides it rather than validating it.
 *
 * The availability comes back with the report so the screen never has to guess
 * what changed: after a learner's report the week has just started, and the meter
 * says so without a second round trip.
 */
export const GENERATE_PROGRESS_REPORT = gql`
  mutation GenerateProgressReport($studentId: ID!, $audience: String) {
    generateProgressReport(studentId: $studentId, audience: $audience) {
      report {
        ...ProgressReportFields
      }
      availability {
        allowed
        blockedBy
        reason
        sessionsDone
        sessionsNeeded
        sessionsLeft
        sessionProgress
        availableAt
        daysLeft
        lastReportAt
      }
      errors
    }
  }
  ${PROGRESS_REPORT_FIELDS}
`

/**
 * Applies one of the changes a report offered, and answers with the row as it
 * now stands — so the button flips to „Pritaikyta" off the server's answer and
 * never off an optimistic guess. Undoing is the same shape, deliberately: these
 * change a learner's record, and „try it and see" is only honest if the way back
 * is one press away.
 *
 * `proficiencyRecord` comes back so the skills screen agrees without a refetch:
 * Apollo normalises it by id, and that is the row the star, the level and the
 * percentage are all drawn from.
 */
export const APPLY_REPORT_ACTION = gql`
  mutation ApplyReportAction($id: ID!) {
    applyReportAction(id: $id) {
      action {
        ...ReportActionFields
      }
      proficiencyRecord {
        id
        proficiency
        isUnlocked
        isPriority
      }
      errors
    }
  }
  ${REPORT_ACTION_FIELDS}
`

export const UNDO_REPORT_ACTION = gql`
  mutation UndoReportAction($id: ID!) {
    undoReportAction(id: $id) {
      action {
        ...ReportActionFields
      }
      proficiencyRecord {
        id
        proficiency
        isUnlocked
        isPriority
      }
      errors
    }
  }
  ${REPORT_ACTION_FIELDS}
`
